import moment from "moment";
import React from "react";
import { ReferenceInput, required, SelectInput } from "react-admin";
import { useFormState, useField } from "react-final-form";

const CcaAcademicYearInput = ({
  parentCallback,
  isActive,
  isDisabled = false,
}: any) => {
  const { values } = useFormState();
  const ccaAcademicTerm = useField("ccaAcademicTermId");
  const date = useField("date");
  const ccaStartedAt = useField("ccaStartedAt");
  const ccaEndedAt = useField("ccaEndedAt");

  return (
    <ReferenceInput
      label="CCA Academic Year"
      source="ccaAcademicYearId"
      reference="ccaAcademicYears"
      filter={
        isActive
          ? {
              SchoolId: values.schoolId ? parseInt(values.schoolId) : 0,
              Date: moment().format("Y-MM-DD"),
            }
          : {
              SchoolId: values.schoolId ? parseInt(values.schoolId) : 0,
              StatusIn: ["Active", "Ready"],
            }
      }
      onChange={({ target }) => {
        parentCallback && parentCallback(target.value);
        ccaAcademicTerm && ccaAcademicTerm.input.onChange("");
        date && date.input.onChange("");

        ccaStartedAt && ccaStartedAt.input.onChange("");
        ccaEndedAt && ccaEndedAt.input.onChange("");
      }}
      validate={required()}
      disabled={isDisabled}
    >
      <SelectInput optionText="name" />
    </ReferenceInput>
  );
};

export default CcaAcademicYearInput;
